import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import styles from "./styles.module.css";

const MAX_ATTEMPTS = 5;
const POLL_INTERVAL_MS = 2000;

function EMandateLoading() {
  const navigate = useNavigate();
  const [authToken] = useSessionStorage("feemonk_data", "");
  const attemptsRef = useRef(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const poll = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/auth`,
          {
            headers: {
              Authorization: `Bearer ${authToken?.value}`,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        const data = await res.json();
        const enachStatus = data?.data?.enachStatus;

        if (enachStatus === 21) {
          navigate("/emandate-success");
          return;
        }
        if (enachStatus === 20) {
          navigate("/emandate-failure");
          return;
        }
      } catch (err) {
        console.error("Error fetching auth data:", err);
      }

      attemptsRef.current += 1;
      if (attemptsRef.current < MAX_ATTEMPTS) {
        timerRef.current = setTimeout(poll, POLL_INTERVAL_MS);
      } else {
        navigate("/emandate-success");
      }
    };

    poll();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [authToken?.value]);

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <img src="/feemonklogo.png" alt="" className={styles.logo} />
        <div className={styles.spinner} />
        <div className={styles.textContainer}>
          <p className={styles.heading}>Processing...</p>
          <p className={styles.subText}>
            Your eMandate is being processed. Please do not close this page.
          </p>
        </div>
      </div>
    </div>
  );
}

export default EMandateLoading;
